import React from "react";
import Dialog, {
  IProps as DialogProps,
} from "../../components/organisms/Dialog";
import { useDialogContext } from "../../context/ContextProvider";

export const initialDialogProps: DialogProps = {
  open: false,
  children: undefined,
};

const DialogContainer = () => {
  const { dialogProps }: { dialogProps: DialogProps } = useDialogContext();
  return <Dialog container="app" {...dialogProps} />;
};

export default DialogContainer;
